import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Modal } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler';

const AvailableBeds = () => {
  const navigate = useNavigate();
  const [rooms, setRooms] = useState([]);
  const [properties, setProperties] = useState([]);
  const [floors, setFloors] = useState([]);
  const [filteredFloors, setFilteredFloors] = useState([]);
  const [form, setForm] = useState({ property_id: "", floor_id: "", room_no: "", no_of_beds: "" });
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [filterPropertyId, setFilterPropertyId] = useState('');
  const [filterFloorId, setFilterFloorId] = useState('');

  const getRooms = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-rooms`, { withCredentials: true })
      .then(res => {
        if (res.data.status) {
          setRooms(res.data.rooms);
        }
        setIsLoading(false);
      })
      .catch(err => globalErrorHandler(err, navigate));
  };

  const getProperties = () => {
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-properties`, { withCredentials: true })
      .then(res => res.data.status && setProperties(res.data.properties))
      .catch(err => globalErrorHandler(err, navigate));
  };

  const getFloors = () => {
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-floors`, { withCredentials: true })
      .then(res => res.data.status && setFloors(res.data.floors))
      .catch(err => globalErrorHandler(err, navigate));
  };

  useEffect(() => {
    getRooms();
    getProperties();
    getFloors();
  }, []);

  return (
    <div className="container-fluid px-4 mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 flex-grow-1">Available Beds</h3>
        <div className="d-flex align-items-center">
          <select
            className="form-select me-2"
            style={{ minWidth: "200px" }}
            value={filterPropertyId}
            onChange={(e) => {
              setFilterPropertyId(e.target.value);
              setFilterFloorId(""); // reset floor when property changes
            }}
          >
            <option value="">All Properties</option>
            {properties.map(p => (
              <option key={p.id} value={p.id}>{p.property_name}</option>
            ))}
          </select>

          <select
            className="form-select me-2"
            style={{ minWidth: "200px" }}
            value={filterFloorId}
            onChange={(e) => setFilterFloorId(e.target.value)}
          >
            <option value="">All Floors</option>
            {floors
              .filter(f => !filterPropertyId || f.property_id == filterPropertyId)
              .map(f => (
                <option key={f.id} value={f.id}>{f.floor_name}</option>
              ))}
          </select>
        </div>
      </div>

      <table className="table table-bordered table-hover shadow-sm">
        <thead className="table-success">
          <tr>
            <th>Property</th>
            <th>Floor</th>
            <th>Room No</th>
            <th>No. of Beds</th>
            <th>Occupied Beds</th>
            <th>Available Beds</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr><td colSpan="6">Loading...</td></tr>
          ) : (
            rooms
              .filter(room =>
                (!filterPropertyId || room.property_id == filterPropertyId) &&
                (!filterFloorId || room.floor_id == filterFloorId)
              )
              .map(room => (
                <tr key={room.id}>
                  <td>{room.property_name || 'N/A'}</td>
                  <td>{room.floor_name || 'N/A'}</td>
                  <td>{room.room_no}</td>
                  <td>{room.no_of_beds}</td>
                  <td>{room.occupied_beds}</td>
                  <td>{room.available_beds}</td>
                </tr>
              ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AvailableBeds;
